// Risk{status,daysLate,consumingOperationName} -> render-ready label (RN50, P-3). UNKNOWN gets
// its own explicit "cannot be assessed" key — never silence, and never a calm/on-time text
// invented from missing data. ON_TIME gets no key at all (same convention as pauseStateLabel's
// NOT_PAUSED): the row simply says nothing about risk when there is none to report.
export const riskLabel = (risk) => {
  const source = risk || {}

  if (source.status === 'AT_RISK') {
    return {
      key: 'Arrives {{days}} days late for {{operation}}',
      values: { days: source.daysLate, operation: source.consumingOperationName }
    }
  }

  if (source.status === 'UNKNOWN') {
    return { key: 'Risk cannot be assessed', values: {} }
  }

  return { key: '', values: {} }
}
